import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Button2.css';
import './DefinitionPage1.css'; // Reuse the same CSS
import {
  BarChart,
  Users,
  UserCheck,
  MapPin,
  BookOpenCheck,
  X as CloseIcon,
} from 'lucide-react';

const CustomButton = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isHovered, setIsHovered] = useState(false);
  const [showDefinition1, setShowDefinition1] = useState(false);
  const [showDefinition2, setShowDefinition2] = useState(false);

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <div className="button2-container">
        <div
          className={`custom-card-button state ${isActive('/state-view') ? 'active' : ''}`}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={() => navigate('/state-view')}
        >
          <MapPin className="icon" />
          <span>Project Achievement View</span>
        </div>

        <div
          className={`custom-card-button ${isActive('/summary') ? 'active' : ''}`}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={() => navigate('/summary')}
        >
          <BarChart className="icon" />
          <span>View Employee Summary</span>
        </div>

        <div
          className={`attractive-card-button ${isHovered ? 'hover' : ''} ${isActive('/all-view') ? 'active' : ''}`}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={() => navigate('/all-view')}
        >
          <UserCheck className="icon" />
          <span>View Individual Performance</span>
        </div>

        <div
          className={`custom-card-button alt ${isActive('/team-view') ? 'active' : ''}`}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={() => navigate('/team-view')}
        >
          <Users className="icon" />
          <span>Team View</span>
        </div>

        {/* This is for the second definition modal */}
        <div
          className="custom-card-button definition-button"
          onClick={() => setShowDefinition2(true)}
        >
          <BookOpenCheck className="icon" />
          <span>Definition</span>
        </div>
      </div>

      {/* Popup for DefinitionPage1 (Project Achievement View) */}
      {showDefinition1 && (
        <div className="definition-overlay">
          <div className="definition-box">
            <button className="close-button" onClick={() => setShowDefinition1(false)}>×</button>
            <h2>Key Definitions - Project Achievement View</h2>
            <p className="definition-note">
              <strong>Note:</strong> The "Last data updated" date and time on the dashboard shows when the data was last refreshed. All information is based on data available up to that point.
            </p>
            <table className="definition-table">
              <tbody>
                {/* ... You can paste the previous DefinitionPage1 content here ... */}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Popup for second definition (View Summary in Tables) */}
      {showDefinition2 && (
        <div className="definition-overlay">
          <div className="definition-box">
            <button className="close-button" onClick={() => setShowDefinition2(false)}>×</button>
            <h2>Key Definitions - View Employee Summary</h2>
            <p className="definition-note">
              <strong>Note:</strong> The "Last data updated" date and time on the dashboard shows when the data was last refreshed. All information is based on data available up to that point.
            </p>

            <table className="definition-table">
              <tbody>
                <tr>
                  <th>PID</th>
                  <td>Choose the project ID you want to view data for.</td>
                </tr>
                <tr>
                  <th>Organization Name</th>
                  <td>Choose the Organization name (State), which corresponds to the state associated with the selected PID.</td>
                </tr>
                <tr>
                  <th>Manager Name</th>
                  <td>Select the manager's name to view data specific to that person.</td>
                </tr>
                <tr>
                  <th>Day Wise Data</th>
                  <td>
                    This table shows you employee-wise, Org-wise detailed daily breakdown of cases for DI, DFL, and YC.
                    By default, it displays the count of BR cases. You can switch to "Open" and "DS" case statuses using the tabs.
                  </td>
                </tr>
                <tr>
                  <th>Weekly Data</th>
                  <td>
                    This table shows you employee-wise, Org-wise detailed weekly breakdown of cases for DI, DFL, and YC.
                    By default, it displays the count of BR cases. You can switch to "Open" and "DS" case statuses using the tabs.
                  </td>
                </tr>
                <tr>
                  <th>Monthly Data</th>
                  <td>
                    This table shows you employee-wise, Org-wise detailed monthly breakdown of cases for DI, DFL, and YC.
                    By default, it displays the count of BR cases. You can switch to "Open" and "DS" case statuses using the tabs.
                  </td>
                </tr>
                <tr>
                  <th>Export Data</th>
                  <td>
                    With this button, you can export the data from the table into an Excel file.
                    If you've applied any filters, only the filtered data that you see in the table will be downloaded.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  );
};

export default CustomButton;
